if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.input = this.querySelector("#cartSpecialInstructions");

        this.input.addEventListener(
          "change",
          this.debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch("/cart/update", {
              ...this.fetchConfig(),
              ...{ body },
            });
          }, 300)
        );
      }

      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }

      fetchConfig(type = "json") {
        return {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: `application/${type}`,
          },
        };
      }
    }
  );
}

if (window.location.href.includes("?poptavka-odeslana")) {
  let formAlert = document.querySelector(".alert");
  formAlert?.classList.remove("hidden");
}

const originalPriceElm = document.querySelector(
  ".product-price--original.money"
);
let priceExclVatElm = document.querySelector(".price__excl-vat");
let priceExclVatTextElm = document.querySelector(".price__excl-vat span");
let productVat = originalPriceElm?.dataset?.vatValue;

// if (originalPriceElm && priceExclVatElm && priceExclVatTextElm && productVat) {
//   const config = { attributes: true, attributeFilter: ["class"] };

//   const callback = function (mutationsList, priceElmObserver) {
//     for (let mutation of mutationsList) {
//       if (
//         mutation.type === "attributes" &&
//         mutation.attributeName === "class"
//       ) {
//         if (mutation.target.classList.contains("pre-money")) {
//           let price = mutation.target.textContent
//             .split(" ")[0]
//             .replace(".", "")
//             .replace(",", ".");
//           let priceNum = Number(price);
//           let vat = productVat / 100;
//           let priceExcldVat = priceNum / (1 + vat);
//           if (priceExcldVat) {
//             priceExclVatTextElm.textContent = priceExcldVat.toFixed(2) + " Kč";
//             priceExclVatElm.classList.remove("hidden");
//           }
//         }
//       }
//     }
//   };

//   const priceElmObserver = new MutationObserver(callback);
//   priceElmObserver.observe(originalPriceElm, config);
// } else {
//   console.error("Element not found");
// }
